/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';
import type { Interpolation } from '@emotion/react';

import * as React from 'react';

import { Typography } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

type Props = {
  headline?: string | null;
  visible?: boolean;
};

const styles: Record<string, Interpolation<Theme>> = {
  headline: (theme) => css`
    margin-bottom: ${theme.spacing(32)};
    ${theme.breakpoints.down('xs')} {
      margin-bottom: 24px;
    }
  `,
};

function Headline({ headline, visible }: Props) {
  if (!visible) {
    return null;
  }
  return (
    <Typography variant="d2semibold" css={styles.headline} color="inherit">
      {headline}
    </Typography>
  );
}

export default Headline;
